import {
  Component,
  OnInit,
  Directive,
  ElementRef,
  Input,
  HostListener
} from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DomSanitizer } from "@angular/platform-browser";
import { DataService } from "../../services/data.service"
import { InProductsService } from "../../services/inventory/in-products.service";
import { InToolsService } from "../../services/inventory/in-tools.service";
import { AuthenticationService } from "../../services/authentication.service";
import { environment } from "../../../../environments/environment";
import { forEach } from "@angular/router/src/utils/collection";

export interface Items {
  title: string;
  text: string;

}

@Component({
  selector: 'app-imageselect',
  templateUrl: './imageselect.component.html',
  styleUrls: ['./imageselect.component.css']
})
export class ImageSelectComponent extends DialogComponent<Items, boolean>
  implements Items, OnInit {

  title: string="";
  text: string="";

  scollable: boolean = false;
  result: any = { result: false, RtnItem: {} };
  @Input() popup: boolean = true;
  loading: boolean = false;
  ImageList:any=[];
  ImageUrl:any=""
  SearchText:string="";

  constructor(dialogService: DialogService, private sanitizer: DomSanitizer, private ds: DataService, 
    private ips: InProductsService, private aut: AuthenticationService) {
    super(dialogService);
  }

  ngOnInit() {
    this.SearchText=this.text;

  }

  onChangeCheckbox(img) {
      this.ImageUrl = img;  
  }

  selectImage(img){
    if(img!=""){
      this.result = { item: img, result: true };
      this.close(); 
    }     
  }

  getImages(){
    if(this.SearchText.length>=3){
      var data = {
        SearchText: this.SearchText,
        GoogleApiKey:this.ds.Settings.GoogleApiKey,
        SearchEngineKey:this.ds.Settings.GoogleSearchEngineKey
      }
      this.loading=true;
      this.ips.Get_ImagesOnFetchImages(data).subscribe(res => {
        if (res.Success) {   
          this.ImageList=res.data;
          this.loading=false;
        }
        else {
          this.ImageList=[];
          this.loading=false;
        }
      })
    }     
  }

  SearchTextKeydown(e){
    if (e.keyCode == 13 && e.which == 13) {
        this.getImages();    
    }  
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/imageselect/imageselect.component.ts